// 分享领额度用的参考文案和配图。文案只写能核实的功能，中文版不放网址（小红书会限流）。
export const shareTemplates = {
  zh: [
    `练口语最烦的就是跟着 YouTube 读，读完一句还得拖进度条找回去，每次都拖不准。

最近在用 GoodScriber，视频导进去自动切成一句一句的，播完一句就停下来等我开口，读完直接给分，还会标出哪个词读得不对，然后自己跳下一句。整个过程不用碰鼠标。

免费账号每个月有 200 额度，够我每天练一会儿了。浏览器搜 GoodScriber 就能用。

#英语口语 #英语跟读 #练口语`,
    `以前自己对着视频读英语，读完根本不知道读得对不对。

现在用 GoodScriber 跟读，每句读完会打分，读错的词直接标出来，哪里有问题一眼就看到。我主要拿它练美剧片段和播客，上传音频也行。

有同样困扰的可以搜 GoodScriber 试试，免费的额度够先体验。

#英语学习 #英语发音 #口语练习`,
    `分享一个我最近每天在用的跟读工具 GoodScriber。

我的用法：找一段喜欢的视频，导进去，它会自动切句加字幕。然后开智能跟读，它放一句我读一句，读完打分自动下一句。一集十几分钟的视频能扎扎实实练完。

不是广告，就是觉得比我之前反复拖进度条好用太多了。

#英语口语 #影子跟读 #英语自学`,
    `打卡第 N 天跟读英语。

用的 GoodScriber，给我最大的感受是终于知道自己哪里读错了。它会把读得不好的单词标出来，我就专门回去多读几遍那个词。

上传自己的音频视频都可以，自动出字幕。想练口语但不知道从哪开始的姐妹可以搜来看看。

#英语打卡 #练口语 #英语发音纠正`,
    `口语党安利一个网站。

GoodScriber 能把一段英语视频或音频切成一句一句，每句可以单独重复听，再跟着读，读完给发音打分。

我觉得最好用的是智能跟读模式，放一句停一下等你说，说完自己往下走，练的时候完全不用管操作，注意力都在嘴上。

浏览器直接搜名字就能用，免费账号每月 200 额度。

#英语学习方法 #英语跟读 #口语提升`,
    `之前一直觉得自己英语发音还行，用 GoodScriber 跟读打了几次分才发现好多词一直读错。

它是逐句练的，播一句、你读一句、马上出分，读错的词会标出来。现在每天通勤前练 15 分钟，感觉开口顺了一点。

#英语口语 #英语发音 #每天练英语`,
    `学英语的朋友看过来，最近挖到的宝藏工具 GoodScriber。

能干的事：上传音频视频自动生成字幕，按句精听，逐句跟读，读完打分。我拿它练雅思口语素材，比自己干读有效率多了。

搜 GoodScriber 就能找到，先用免费额度试试。

#雅思口语 #英语跟读 #英语学习工具`,
    `给想练听说的人推荐一下 GoodScriber。

我是拿它练播客，一段二三十分钟的音频传上去，自动切句出字幕。听不懂的句子单独循环，然后跟着读，它会告诉我哪个词发音有问题。

用了一阵，听力和开口都比之前自信一点。

#英语听力 #英语口语 #播客学英语`
  ],
  en: [
    `the most annoying part of shadowing youtube videos? dragging the timeline back to the last sentence. every. single. time.

been using GoodScriber lately. it splits the video into sentences, pauses after each one and waits for me to speak, scores it, flags the words i got wrong, then moves on by itself. no mouse needed.

free account gets 200 credits a month. just search GoodScriber

#englishspeaking #shadowing #learnenglish`,
    `i used to read along with videos and had zero idea if i was saying anything right.

now i shadow with GoodScriber. every sentence gets a score and the words i mess up are highlighted, so i know exactly what to fix. works with your own audio or video too.

#englishpronunciation #speakingpractice #esl`,
    `my daily english routine lately:

pick a video i like, drop it into GoodScriber, it auto splits it into sentences with subtitles. then smart shadowing: it plays one line, i repeat, i get a score, next line. a 15 min video actually gets practiced start to finish.

not sponsored, it's just way better than rewinding over and over.

#learnenglish #shadowingtechnique #englishlearning`,
    `thought my pronunciation was fine until GoodScriber started scoring me sentence by sentence lol

it highlights every word you get wrong, so now i drill those specific words. 15 minutes before work every day and speaking already feels a bit smoother.

#englishpronunciation #englishspeaking #dailypractice`,
    `if you're practicing english listening and speaking, try GoodScriber.

i upload podcast episodes, it makes subtitles and splits them into sentences. i loop the lines i don't get, shadow them, and it tells me which words sound off.

search GoodScriber, the free credits are enough to try it out.

#englishlistening #podcastenglish #learnenglishonline`,
    `ielts speaking prep tip: stop just reading your notes out loud.

i load practice audio into GoodScriber and shadow it line by line. it scores each sentence and marks the words i mispronounce, so practice actually turns into feedback.

#ielts #ieltsspeaking #englishspeaking`
  ]
}

// 由 launch-video 的 share-* 静帧渲染（src/share/ShareCard.tsx），中文 3:4，英文 4:5
export const shareImages = {
  zh: [
    { src: '/share-kit/zh-shadow.jpg', name: 'goodscriber-智能跟读.jpg' },
    { src: '/share-kit/zh-score.jpg', name: 'goodscriber-发音打分.jpg' },
    { src: '/share-kit/zh-split.jpg', name: 'goodscriber-自动切句.jpg' }
  ],
  en: [
    { src: '/share-kit/en-shadow.jpg', name: 'goodscriber-shadowing.jpg' },
    { src: '/share-kit/en-score.jpg', name: 'goodscriber-score.jpg' },
    { src: '/share-kit/en-split.jpg', name: 'goodscriber-sentences.jpg' }
  ]
}
